import * as d3 from "d3";
import { useEffect, useRef } from "react";

import styles from "./histogram.module.scss";

const Histogram = ({ frequencies, bins }) => {
  const svgRef = useRef(null);

  useEffect(() => {
    const height = 60;
    const margin = { top: 0, right: 0, bottom: 0, left: 0 };
    const svg = d3.select(svgRef.current);
    const svgWidth = svgRef.current.getBoundingClientRect().width;

    svg.selectAll("*").remove();

    const x = d3
      .scaleLinear()
      .domain([d3.min(bins), d3.max(bins)])
      .range([margin.left, svgWidth - margin.right]);

    const y = d3
      .scaleLinear()
      .domain([0, d3.max(frequencies)])
      .range([height - margin.bottom, margin.top]);

    const barWidth = (svgWidth - margin.left - margin.right) / bins.length;

    svg
      .selectAll("rect")
      .data(frequencies)
      .enter()
      .append("rect")
      .attr("x", (_, i) => x(bins[i]))
      .attr("y", (d) => y(d))
      .attr("width", barWidth)
      .attr("height", (d) => height - margin.bottom - y(d))
      .attr("fill", (d) => d3.interpolateCool(d / d3.max(frequencies)));
  }, [frequencies, bins]);

  return <svg className={styles["histogram"]} ref={svgRef}></svg>;
};

export default Histogram;
